import { SET_EMPLOYEE_GOALS_ACCESS_PRIVILEGES } from './actionTypes';

export function setEmployeeGoalsAccessPrivilegesAction(accessPrivileges = []) {
  return (dispatch) => {
    dispatch({
      type: SET_EMPLOYEE_GOALS_ACCESS_PRIVILEGES,
      payload: { accessPrivileges },
    });
  };
}
